<div class="main-details-container relative">
  <div class="close-icon d-flex justify-content-center align-items-center pointer" (click)="close()">
    <i class="fa fa-times"></i>
  </div>
  <div class="details-container">
    <div class="row">
      <div class="col-md-9 d-flex align-items-center">
        <img src="assets/persons.svg" alt="">
        <div class="text ml-10">
          <p class="t-fs14 t-fw700 m-0">PASSENGER DETAILS</p>
          <p class="t-fs12 m-0">{{ data?.details?.plateNumber }}</p>
        </div>
      </div>
      <div class="col-md-3 d-flex justify-content-end align-items-center">
        <p class="t-fs12 m-0">{{ data?.details?.passengerCount }}/{{ data?.details?.maxSeat }}</p>
      </div>
    </div>

    <ng-container *ngIf="data?.details?.activePassengers || data?.details?.activePassengers?.length > 0">
      <div class="row heading mt-4 mb-4">
        <div class="col-md-6">
          <p class="t-fs12 t-fw700 m-0">Passengers</p>
        </div>
        <div class="col-md-6 d-flex justify-content-end">
          <p class="t-fs12 t-fw700 m-0">Origin</p>
        </div>
      </div>

      <div class="row content mt-2 gradient-border" *ngFor="let item of data?.details?.activePassengers; let i=index">
        <div class="col-md-1 d-flex justify-content-start align-items-center">
          <p class="t-fs12 t-fw700 m-0">{{ i+1 }}</p>
        </div>
        <div class="col-md-1 d-flex justify-content-center align-items-center">
          <img src="assets/icons/pwd.svg" alt="" *ngIf="item?.userPWD == 'yes'">
          <img src="assets/icons/regular.svg" alt="" *ngIf="item?.userPWD == 'no' && item?.userSenior == 'no'">
          <img src="assets/icons/senior.svg" alt="" *ngIf="item?.userSenior == 'yes'">
        </div>
        <div class="col-md-6 d-flex justify-content-start align-items-center">
          <p class="t-fs12 t-fw700 m-0">{{ maskString(item?.riderName) }}</p>
        </div>
        <div class="col-md-4 d-flex justify-content-end align-items-center">
          <p class="t-fs12 t-fw700 m-0">{{ item?.originStopName }}</p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!data?.details?.activePassengers || data?.details?.activePassengers?.length == 0">
      <div class="row">
        <div class="col-md-12 d-flex justify-content-center align-items-center">
          <img src="assets/no-passenger-ph.svg" alt="">
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center">
          <p class="t-fs14 t-fw700 m-0">No passengers on board</p>
          <p class="t-fs12 m-0 mt-2">This unit is currently empty. Once passengers start boarding, real-time counts will appear here.</p>
        </div>
      </div>
    </ng-container>
  </div>
</div>